// extracted by mini-css-extract-plugin
export default {"sidebarWrapper":"AppSidebar_sidebarWrapper__LOQ-E"};